export const defaultContent = {
  email: "hello@chloe.studio",
  images: {
    hero: "/assets/new1.jpg",
    journey: "/assets/new5.jpg",
    archivePlant: "/assets/new2.jpg",
    archiveReading: "/assets/new3.jpg",
    archiveTravel: "/assets/new8.jpg",
    archiveCover: "/assets/new1.jpg",
    archiveDenimOne: "/assets/new6.jpg",
    archiveDenimTwo: "/assets/new7.jpg",
    social: "/assets/new1.jpg",
  },
  sections: {
    manifesto: true,
    approach: true,
    organic: true,
    cases: true,
    journey: true,
    archive: true,
    about: true,
    notes: true,
    contact: true,
  },
  caseStudies: [
    {
      id: "discovery",
      vi: {
        eyebrow: "Tình huống 01 · Khám phá nhu cầu",
        title: "Khi khách hàng chưa thể gọi tên điều mình cần.",
        challenge:
          "Khách hàng quan tâm nhưng còn mơ hồ, đưa ra nhiều mong muốn rời rạc và chưa sẵn sàng nghe một lời chào bán.",
        approach:
          "Chloe sẽ chậm lại, hỏi về bối cảnh, ưu tiên và điều khiến họ băn khoăn. Thay vì giới thiệu mọi thứ, cô tóm tắt nhu cầu bằng ngôn ngữ của chính khách hàng rồi mới đề xuất một hướng phù hợp.",
        outcome:
          "Một cuộc trò chuyện rõ ràng hơn — nơi khách hàng hiểu lựa chọn của mình trước khi đưa ra quyết định.",
      },
      en: {
        eyebrow: "Scenario 01 · Discovery",
        title: "When a customer cannot yet name what they need.",
        challenge:
          "The customer is interested but uncertain, sharing disconnected wishes and not yet ready for a sales pitch.",
        approach:
          "Chloe would slow the conversation down, ask about context, priorities and concerns, then reflect the need back in the customer’s own language before suggesting a direction.",
        outcome:
          "A clearer conversation in which the customer understands their options before making a decision.",
      },
    },
    {
      id: "value",
      vi: {
        eyebrow: "Tình huống 02 · Diễn giải giá trị",
        title: "Khi giá trị chưa thể nhìn thấy ngay.",
        challenge:
          "Sản phẩm hoặc dịch vụ có nhiều điểm tốt, nhưng thông tin đang quá kỹ thuật hoặc chưa gắn với điều người mua thật sự quan tâm.",
        approach:
          "Chloe sẽ chọn lọc những lợi ích liên quan nhất, dùng ví dụ cụ thể và so sánh dễ hiểu. Cô nói rõ cả điểm phù hợp lẫn giới hạn để sự tin tưởng đến từ thông tin, không phải áp lực.",
        outcome:
          "Giá trị trở nên gần gũi, dễ nhớ và đủ rõ để khách hàng tự tin cân nhắc.",
      },
      en: {
        eyebrow: "Scenario 02 · Value translation",
        title: "When the value is not immediately visible.",
        challenge:
          "The offer has real strengths, but the information feels too technical or disconnected from what the buyer genuinely cares about.",
        approach:
          "Chloe would select the most relevant benefits, use concrete examples and explain both fit and limits so trust comes from clarity rather than pressure.",
        outcome:
          "The value feels human, memorable and clear enough for the customer to consider with confidence.",
      },
    },
    {
      id: "follow-up",
      vi: {
        eyebrow: "Tình huống 03 · Theo sát tinh tế",
        title: "Khi câu trả lời là “để tôi suy nghĩ thêm”.",
        challenge:
          "Khách hàng chưa từ chối, nhưng cần thêm thời gian và không muốn bị thúc ép bởi những tin nhắn lặp lại.",
        approach:
          "Chloe sẽ ghi nhận điều còn chưa chắc chắn, thống nhất một thời điểm phù hợp để liên hệ lại và chỉ gửi thêm thông tin khi nó thật sự giúp ích cho quyết định.",
        outcome:
          "Mối quan hệ vẫn được tôn trọng, cánh cửa trao đổi còn mở và mỗi lần theo sát đều có lý do.",
      },
      en: {
        eyebrow: "Scenario 03 · Thoughtful follow-up",
        title: "When the answer is “let me think about it”.",
        challenge:
          "The customer has not said no, but needs time and does not want to be chased by repetitive messages.",
        approach:
          "Chloe would clarify what still feels uncertain, agree on an appropriate time to reconnect and only share information that genuinely helps the decision.",
        outcome:
          "The relationship remains respected, the conversation stays open and every follow-up has a purpose.",
      },
    },
  ],
  translations: {
    vi: {
      "meta.title": "CHLOE — Sales bằng sự thấu hiểu",
      "meta.description":
        "Chloe theo đuổi cách làm sales dựa trên sự lắng nghe, thấu hiểu nhu cầu và xây dựng những mối quan hệ lâu dài.",
      "accessibility.skip": "Đi tới nội dung",
      "accessibility.menu": "Mở menu",
      "brand.issue": "Sales · Xây dựng quan hệ",
      "nav.approach": "Cách tôi làm việc",
      "nav.organic": "Giá trị bán hàng",
      "nav.cases": "Tình huống",
      "nav.journey": "Những chuyến đi",
      "nav.about": "Về Chloe",
      "nav.contact": "Liên hệ",
      "hero.role": "Sales · Tư vấn & xây dựng quan hệ",
      "hero.availability": "Đang mở cho những cơ hội sales phù hợp",
      "hero.eyebrow": "Một cách làm sales dịu dàng và có chiều sâu",
      "hero.lineOne": "Bán bằng sự",
      "hero.lineTwo": "thấu hiểu.",
      "hero.intro":
        "Chloe kết nối sản phẩm và dịch vụ với đúng người — bằng sự lắng nghe, khả năng thấu hiểu nhu cầu và những mối quan hệ được nuôi dưỡng lâu dài.",
      "hero.focus":
        "Không đóng khung trong một ngành hàng — sẵn sàng học nhanh để hiểu sản phẩm, thị trường và con người.",
      "hero.ctaWork": "Hiểu cách Chloe làm việc",
      "hero.ctaContact": "Bắt đầu một cuộc trò chuyện",
      "hero.imageAlt": "Chân dung chuyển động của Chloe trong ánh sáng studio ấm",
      "hero.captionOne": "Một người quan sát trước khi lên tiếng",
      "hero.captionTwo": "Ghi chép riêng / 01",
      "hero.qualityOne": "Lắng nghe kỹ",
      "hero.qualityTwo": "Hiểu sản phẩm",
      "hero.qualityThree": "Xây niềm tin",
      "manifesto.label": "Quan điểm",
      "manifesto.title": "Không cần nói thật nhiều để tạo nên một kết nối thật.",
      "manifesto.lead":
        "Chloe sống khá khép kín, nhưng trong công việc lại dành rất nhiều sự chú ý cho con người: điều họ cần, điều họ chưa nói và điều khiến họ thật sự tin tưởng.",
      "manifesto.body":
        "Với cô, sales không phải là thuyết phục bằng mọi giá. Đó là tìm đúng sản phẩm, đúng câu chuyện và đúng thời điểm để một lựa chọn tốt trở nên tự nhiên.",
      "approach.label": "Cách làm việc",
      "approach.eyebrow": "Sales đặt mối quan hệ làm trung tâm",
      "approach.title": "Ít áp lực hơn. Nhiều thấu hiểu hơn.",
      "approach.intro":
        "Một cách tiếp cận sales bình tĩnh, có chuẩn bị và đặt mối quan hệ dài hạn ở trung tâm.",
      "approach.one.title": "Lắng nghe trước khi đề xuất",
      "approach.one.body":
        "Hiểu nhu cầu thật, bối cảnh kinh doanh và những khoảng trống chưa được gọi tên trước khi nói về sản phẩm.",
      "approach.two.title": "Diễn giải giá trị rõ ràng",
      "approach.two.body":
        "Chuyển đặc điểm, lợi ích và điểm khác biệt thành một câu chuyện rõ ràng, gần gũi và đúng với điều khách hàng quan tâm.",
      "approach.three.title": "Chăm một mối quan hệ dài lâu",
      "approach.three.body":
        "Theo sát sau mỗi cuộc trao đổi, giữ lời và để sự tử tế nhất quán trở thành lý do người khác muốn đồng hành.",
      "organic.label": "Giá trị bán hàng",
      "organic.eyebrow": "Từ thấu hiểu đến lựa chọn",
      "organic.title": "Một lựa chọn tốt bắt đầu từ sự thấu hiểu.",
      "organic.body":
        "Mỗi sản phẩm hay dịch vụ đều có một giá trị riêng. Công việc của Chloe là hiểu điều khách hàng thật sự cần, nắm rõ giải pháp mình đại diện và kết nối hai điều ấy bằng một cuộc trò chuyện chân thành.",
      "organic.one.kicker": "Lắng nghe nhu cầu",
      "organic.one.title": "Bắt đầu từ điều khách hàng thật sự cần",
      "organic.one.body": "Tìm hiểu mục tiêu, bối cảnh và những băn khoăn trước khi đề xuất một giải pháp.",
      "organic.two.kicker": "Hiểu giải pháp",
      "organic.two.title": "Nắm rõ điều mình đang giới thiệu",
      "organic.two.body": "Hiểu đặc điểm, lợi ích và giới hạn để tư vấn rõ ràng, phù hợp và có trách nhiệm.",
      "organic.three.kicker": "Diễn giải giá trị",
      "organic.three.title": "Biến giá trị thành điều dễ hiểu",
      "organic.three.body":
        "Nói đúng điều người mua quan tâm bằng ngôn ngữ gần gũi, không tô vẽ và không gây áp lực.",
      "organic.four.kicker": "Xây quan hệ",
      "organic.four.title": "Đồng hành cả sau quyết định",
      "organic.four.body":
        "Theo dõi, phản hồi và để sự nhất quán trở thành nền tảng cho những cơ hội lâu dài.",
      "cases.label": "Tình huống sales",
      "cases.eyebrow": "Field notes · Cách Chloe suy nghĩ",
      "cases.title": "Không chỉ nói mình sẽ làm gì. Cho thấy cách mình nghĩ.",
      "cases.intro":
        "Ba tình huống giả định cho thấy cách Chloe lắng nghe, diễn giải giá trị và giữ sự tinh tế trong từng điểm chạm.",
      "cases.challenge": "Bối cảnh",
      "cases.approach": "Cách tiếp cận",
      "cases.outcome": "Điều hướng tới",
      "cases.disclaimer": "Tình huống tư duy · Không phải số liệu dự án thực tế",
      "journey.imageAlt": "Chloe giữa ánh sáng thành phố về đêm",
      "journey.captionOne": "Một góc phố, một nhịp đi chậm",
      "journey.label": "Những chuyến đi",
      "journey.eyebrow": "Đi xa, hiểu gần",
      "journey.title": "Đi xa để hiểu con người gần hơn.",
      "journey.lead":
        "Chloe thích những chuyến đi không quá vội — nơi có thể quan sát cách người ta ăn, sống, chọn một món đồ và dành thời gian cho nhau.",
      "journey.quote":
        "“Mỗi nơi đều có một nhịp riêng. Chỉ khi chậm lại, mình mới thật sự nghe thấy.”",
      "journey.noteOne": "Chợ địa phương",
      "journey.noteTwo": "Quán cà phê yên tĩnh",
      "journey.noteThree": "Những cung đường dài",
      "journey.noteFour": "Bữa ăn có câu chuyện",
      "archive.label": "Nhật ký hình ảnh",
      "archive.eyebrow": "Kho lưu trữ riêng · 2000",
      "archive.title": "Những khoảnh khắc nhỏ, được giữ lại thật khẽ.",
      "archive.intro":
        "Một bộ ảnh như những trang ghi chú — về cách Chloe quan sát, đi xa, đọc chậm và giữ lại những điều bình dị.",
      "archive.plant": "Vùng sáng yên tĩnh · 01",
      "archive.plantAlt": "Chân dung Chloe trong vùng sáng studio ấm",
      "archive.reading": "Một thước film dịu · 02",
      "archive.readingAlt": "Chân dung Chloe mang sắc film trong nắng ngược",
      "archive.travel": "Lặng giữa ánh neon · 03",
      "archive.travelAlt": "Chloe trong khoảnh khắc tĩnh lặng trước ánh đèn neon",
      "archive.cover": "Chân dung trong tĩnh lặng · 04",
      "archive.coverAlt": "Chân dung gần của Chloe trong ánh sáng studio",
      "archive.denimOne": "Dưới vòm lá xanh · 05",
      "archive.denimOneAlt": "Chloe trong khoảnh khắc yên tĩnh dưới vòm lá xanh",
      "archive.denimTwo": "Giữa những trang sách · 06",
      "archive.denimTwoAlt": "Chloe dừng lại giữa những kệ sách trong hiệu sách",
      "about.label": "Về Chloe",
      "about.lineOne": "Kín đáo theo bản tính.",
      "about.lineTwo": "Chú tâm bởi lựa chọn.",
      "about.bodyOne":
        "Sinh ngày 14 tháng 11 năm 2000, Chloe là một người hướng nội, yêu khoảng riêng và thường tìm thấy năng lượng trong những điều giản dị.",
      "about.bodyTwo":
        "Sự yên lặng giúp cô quan sát tinh hơn; công việc sales giúp cô bước ra khỏi thế giới riêng để tạo nên những kết nối có ý nghĩa. Cô tin rằng một người làm sales tốt không chỉ biết nói, mà còn phải biết lắng nghe, học nhanh và khiến người khác cảm thấy được tôn trọng.",
      "about.factOne.label": "Bản tính",
      "about.factOne.value": "Người quan sát yên lặng",
      "about.factTwo.label": "Công việc",
      "about.factTwo.value": "Sales & phát triển khách hàng",
      "about.factThree.label": "Cách kết nối",
      "about.factThree.value": "Lắng nghe rồi mới nói",
      "about.factFour.label": "Ngoài công việc",
      "about.factFour.value": "Du lịch & góc nhỏ yên tĩnh",
      "notes.label": "Ghi chép riêng",
      "notes.title": "Những điều nhỏ nói lên một con người.",
      "notes.one.title": "Sự chân thành không cần âm lượng",
      "notes.one.body":
        "Một cuộc trò chuyện tốt không nằm ở việc nói bao nhiêu, mà ở cảm giác người đối diện thật sự được lắng nghe.",
      "notes.two.title": "Muốn bán tốt, trước hết phải hiểu điều mình giới thiệu",
      "notes.two.body":
        "Khi hiểu rõ giá trị, lợi ích và giới hạn của một sản phẩm hay dịch vụ, việc tư vấn trở nên tự nhiên và đáng tin hơn rất nhiều.",
      "notes.three.title": "Đi xa không phải để chạy trốn",
      "notes.three.body":
        "Đó là cách đổi góc nhìn, nhìn lại chính mình và mang về những câu chuyện đáng nhớ.",
      "contact.label": "Liên hệ",
      "contact.kicker": "Một cuộc trò chuyện vừa đủ",
      "contact.lineOne": "Hãy bắt đầu bằng",
      "contact.lineTwo": "một lời chào.",
      "contact.body":
        "Nếu bạn đang tìm một người làm sales chú trọng sự thấu hiểu, muốn trao đổi về cơ hội nghề nghiệp, hợp tác hoặc đơn giản là có một câu chuyện hay — Chloe luôn sẵn lòng lắng nghe.",
      "contact.email": "Viết email cho Chloe",
      "contact.copy": "Sao chép email",
      "contact.availability": "Sẵn sàng cho những cơ hội phù hợp · GMT+7",
      "contact.form.name": "Tên của bạn",
      "contact.form.namePlaceholder": "Chloe nên gọi bạn thế nào?",
      "contact.form.email": "Địa chỉ email",
      "contact.form.emailPlaceholder": "ban@example.com",
      "contact.form.subject": "Chủ đề",
      "contact.form.subjectPlaceholder": "Sales, cơ hội nghề nghiệp, hợp tác…",
      "contact.form.message": "Lời nhắn",
      "contact.form.messagePlaceholder": "Hãy kể Chloe nghe một chút…",
      "contact.form.submit": "Gửi lời nhắn",
      "contact.form.sending": "Đang gửi…",
      "contact.form.success": "Cảm ơn bạn — Chloe đã nhận được lời nhắn.",
      "contact.form.error": "Chưa thể gửi lời nhắn. Vui lòng thử lại hoặc dùng email.",
      "footer.line": "Relationship-led sales · Lặng lẽ xây dựng những kết nối bền lâu.",
      "footer.back": "Về đầu trang",
      "toast.copied": "Đã sao chép email",
    },
    en: {
      "meta.title": "CHLOE — Sales through understanding",
      "meta.description":
        "Chloe approaches sales through attentive listening, thoughtful guidance and relationships built to last.",
      "accessibility.skip": "Skip to content",
      "accessibility.menu": "Open menu",
      "brand.issue": "Sales · Relationship builder",
      "nav.approach": "My approach",
      "nav.organic": "Creating value",
      "nav.cases": "Scenarios",
      "nav.journey": "Journeys",
      "nav.about": "About Chloe",
      "nav.contact": "Contact",
      "hero.role": "Sales · Advisor & relationship builder",
      "hero.availability": "Open to thoughtful sales opportunities",
      "hero.eyebrow": "A softer, more thoughtful way to sell",
      "hero.lineOne": "Selling through",
      "hero.lineTwo": "understanding.",
      "hero.intro":
        "Chloe connects products and services with the right people — through attentive listening, a clear understanding of needs and relationships made to last.",
      "hero.focus":
        "Not defined by one industry — ready to learn quickly and understand the product, market and people behind every decision.",
      "hero.ctaWork": "Discover Chloe’s approach",
      "hero.ctaContact": "Start a conversation",
      "hero.imageAlt": "A moving portrait of Chloe in warm studio light",
      "hero.captionOne": "An observer before a speaker",
      "hero.captionTwo": "Private notes / 01",
      "hero.qualityOne": "Listen closely",
      "hero.qualityTwo": "Know the product",
      "hero.qualityThree": "Earn the trust",
      "manifesto.label": "Point of view",
      "manifesto.title": "You do not have to say much to make a real connection.",
      "manifesto.lead":
        "Reserved by nature, Chloe gives people her full attention at work: what they need, what they have not said and what helps them genuinely trust.",
      "manifesto.body":
        "To her, sales is never persuasion at any cost. It is finding the right product, the right story and the right moment for a good choice to feel natural.",
      "approach.label": "My approach",
      "approach.eyebrow": "Relationship-led sales",
      "approach.title": "Less pressure. More understanding.",
      "approach.intro":
        "A calm, prepared approach to sales that keeps the long-term relationship at its centre.",
      "approach.one.title": "Listen before offering",
      "approach.one.body":
        "Understand the real need, the business context and the gaps left unsaid before talking about a product.",
      "approach.two.title": "Communicate value clearly",
      "approach.two.body":
        "Turn features, benefits and meaningful differences into a clear, human story that speaks to what customers value.",
      "approach.three.title": "Care for the long relationship",
      "approach.three.body":
        "Follow through after every conversation, keep promises and let consistent care become the reason people stay.",
      "organic.label": "Creating value",
      "organic.eyebrow": "From understanding to choice",
      "organic.title": "A good choice begins with understanding.",
      "organic.body":
        "Every product or service holds a distinct kind of value. Chloe’s work is to understand what people truly need, know the solution she represents and connect the two through an honest conversation.",
      "organic.one.kicker": "Listen to the need",
      "organic.one.title": "Begin with what people truly need",
      "organic.one.body": "Understand the goal, context and concerns before suggesting a solution.",
      "organic.two.kicker": "Know the solution",
      "organic.two.title": "Understand what you represent",
      "organic.two.body": "Know the strengths, benefits and limits well enough to guide with clarity and care.",
      "organic.three.kicker": "Translate the value",
      "organic.three.title": "Make the value easy to understand",
      "organic.three.body": "Speak to what buyers care about in human language, without pressure or overclaiming.",
      "organic.four.kicker": "Build the relationship",
      "organic.four.title": "Stay present beyond the decision",
      "organic.four.body": "Follow up, respond and let consistency become the foundation for lasting opportunities.",
      "cases.label": "Sales scenarios",
      "cases.eyebrow": "Field notes · How Chloe thinks",
      "cases.title": "Do not only say what you would do. Show how you think.",
      "cases.intro":
        "Three considered scenarios reveal how Chloe listens, translates value and keeps every customer touchpoint thoughtful.",
      "cases.challenge": "The context",
      "cases.approach": "The approach",
      "cases.outcome": "What it moves towards",
      "cases.disclaimer": "Thinking exercise · Not presented as real project results",
      "journey.imageAlt": "Chloe among the city lights at night",
      "journey.captionOne": "A city corner, taken at a slower pace",
      "journey.label": "Journeys",
      "journey.eyebrow": "Away, but closer",
      "journey.title": "Going farther to understand people better.",
      "journey.lead":
        "Chloe is drawn to unhurried journeys — places where she can notice how people eat, live, choose an object and make time for one another.",
      "journey.quote":
        "“Every place has its own rhythm. Only when I slow down can I truly hear it.”",
      "journey.noteOne": "Local markets",
      "journey.noteTwo": "Quiet cafés",
      "journey.noteThree": "Long roads",
      "journey.noteFour": "Meals with a story",
      "archive.label": "Image journal",
      "archive.eyebrow": "Private archive · 2000",
      "archive.title": "Small moments, kept with a quiet kind of care.",
      "archive.intro":
        "A collection of photographs arranged like field notes — observing, travelling, reading slowly and keeping the ordinary close.",
      "archive.plant": "A quiet pool of light · 01",
      "archive.plantAlt": "A portrait of Chloe in warm studio light",
      "archive.reading": "A softly lit film frame · 02",
      "archive.readingAlt": "A film-toned portrait of Chloe in backlight",
      "archive.travel": "Stillness in neon · 03",
      "archive.travelAlt": "Chloe in a quiet moment before a neon glow",
      "archive.cover": "A portrait in stillness · 04",
      "archive.coverAlt": "A close portrait of Chloe in studio light",
      "archive.denimOne": "Beneath the green canopy · 05",
      "archive.denimOneAlt": "Chloe in a quiet moment beneath a green canopy",
      "archive.denimTwo": "Among pages · 06",
      "archive.denimTwoAlt": "Chloe pausing among the shelves in a bookshop",
      "about.label": "About Chloe",
      "about.lineOne": "Reserved by nature.",
      "about.lineTwo": "Attentive by choice.",
      "about.bodyOne":
        "Born on 14 November 2000, Chloe is an introvert who values privacy and often finds energy in simple, quiet things.",
      "about.bodyTwo":
        "Stillness helps her observe more closely; sales invites her beyond her inner world to create meaningful connections. She believes a good salesperson does more than speak well — they listen carefully, learn quickly and make people feel respected.",
      "about.factOne.label": "Nature",
      "about.factOne.value": "Quiet observer",
      "about.factTwo.label": "Work",
      "about.factTwo.value": "Sales & customer development",
      "about.factThree.label": "Connection",
      "about.factThree.value": "Listen, then speak",
      "about.factFour.label": "Beyond work",
      "about.factFour.value": "Travel & quiet corners",
      "notes.label": "Private notes",
      "notes.title": "Small things that say something true.",
      "notes.one.title": "Sincerity does not need volume",
      "notes.one.body":
        "A good conversation is not measured by how much is said, but by whether the other person feels truly heard.",
      "notes.two.title": "To sell well, first understand what you represent",
      "notes.two.body":
        "When you understand the value, benefits and limits of a product or service, guiding someone towards it feels more natural and trustworthy.",
      "notes.three.title": "Going away is not running away",
      "notes.three.body":
        "It is a way to change perspective, meet yourself again and bring home stories worth keeping.",
      "contact.label": "Contact",
      "contact.kicker": "A conversation, just enough",
      "contact.lineOne": "Let’s begin with",
      "contact.lineTwo": "a simple hello.",
      "contact.body":
        "If you are looking for a thoughtful sales professional, want to discuss a role, collaboration or simply have a good story to share — Chloe is always willing to listen.",
      "contact.email": "Write to Chloe",
      "contact.copy": "Copy email",
      "contact.availability": "Open to thoughtful opportunities · GMT+7",
      "contact.form.name": "Your name",
      "contact.form.namePlaceholder": "How should Chloe call you?",
      "contact.form.email": "Email address",
      "contact.form.emailPlaceholder": "you@example.com",
      "contact.form.subject": "Subject",
      "contact.form.subjectPlaceholder": "Sales, career opportunities, collaboration…",
      "contact.form.message": "Your note",
      "contact.form.messagePlaceholder": "Tell Chloe a little more…",
      "contact.form.submit": "Send a note",
      "contact.form.sending": "Sending…",
      "contact.form.success": "Thank you — your note has reached Chloe.",
      "contact.form.error": "The note could not be sent. Please try again or use email.",
      "footer.line": "Relationship-led sales · Quietly building connections that last.",
      "footer.back": "Back to top",
      "toast.copied": "Email copied",
    },
  },
};

window.CHLOE_PORTFOLIO = defaultContent;
